import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, MessageCircle, Settings, Clock } from 'lucide-react';
export function ContactForm() {
  const [formData, setFormData] = useState({
    nombre: '',
    empresa: '',
    telefono: '',
    tamano: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      setFormData({
        nombre: '',
        empresa: '',
        telefono: '',
        tamano: ''
      });
      setTimeout(() => setIsSuccess(false), 5000);
    }, 1000);
  };
  return <section id="contacto" className="py-14 sm:py-20 bg-white border-t border-gray-200" data-id="element-21">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-22">
        <div className="text-center mb-10 sm:mb-12" data-id="element-23">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-gray-900 mb-4" data-id="element-24">
            Trae el chat de tu obra. Te mostramos qué se puede sacar.
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-25">
            Carga el archivo de WhatsApp de una obra que ya tengas. En 24 horas
            te mostramos el resumen, el reporte y la plataforma con tus datos.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-gray-50 rounded-2xl border border-gray-200 shadow-sm p-6 sm:p-10" data-id="element-26">
          {isSuccess ? <div className="text-center py-12" data-id="element-27">
              <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-100 mb-6" data-id="element-28">
                <CheckCircle2 className="h-8 w-8 text-green-600" data-id="element-29" />
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-30">
                ¡Gracias por tu interés!
              </h3>
              <p className="text-gray-600" data-id="element-31">
                Hemos recibido tus datos. Nos pondremos en contacto contigo a la
                brevedad.
              </p>
              <button onClick={() => setIsSuccess(false)} className="mt-8 text-blue-600 font-medium hover:text-blue-800" data-id="element-32">
                Enviar otro mensaje
              </button>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-33">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-34">
                <div data-id="element-35">
                  <label htmlFor="nombre" className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-36">
                    Nombre completo *
                  </label>
                  <input type="text" id="nombre" name="nombre" required value={formData.nombre} onChange={handleChange} className="block w-full rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm border p-3.5" placeholder="Juan Pérez" data-id="element-37" />
                </div>
                <div data-id="element-38">
                  <label htmlFor="empresa" className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-39">
                    Empresa *
                  </label>
                  <input type="text" id="empresa" name="empresa" required value={formData.empresa} onChange={handleChange} className="block w-full rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm border p-3.5" placeholder="Constructora XYZ" data-id="element-40" />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-41">
                <div data-id="element-42">
                  <label htmlFor="telefono" className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-43">
                    Teléfono *
                  </label>
                  <input type="tel" id="telefono" name="telefono" required value={formData.telefono} onChange={handleChange} className="block w-full rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm border p-3.5" placeholder="+56 9 1234 5678" data-id="element-44" />
                </div>
                <div data-id="element-45">
                  <label htmlFor="tamano" className="block text-sm font-semibold text-gray-700 mb-1.5" data-id="element-46">
                    Tamaño aprox. de obra (m²)
                  </label>
                  <input type="text" id="tamano" name="tamano" value={formData.tamano} onChange={handleChange} className="block w-full rounded-xl border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm border p-3.5" placeholder="Ej: 5000 m2" data-id="element-47" />
                </div>
              </div>

              <div className="pt-4" data-id="element-48">
                <button type="submit" disabled={isSubmitting} className={`w-full flex justify-center py-4 px-4 border border-transparent rounded-xl shadow-sm text-base font-bold text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors ${isSubmitting ? 'opacity-75 cursor-not-allowed' : ''}`} data-id="element-49">
                  {isSubmitting ? 'Enviando...' : 'Quiero probar Obra Digital'}
                </button>
                <p className="text-center mt-4 text-xs font-medium text-gray-500" data-id="element-50">
                  También puedes mandarnos solo un fragmento. No necesitas el
                  chat completo.
                </p>
              </div>
            </form>}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="flex flex-col sm:flex-row flex-wrap justify-center gap-5 sm:gap-8 mt-10" data-id="element-51">
          <div className="flex items-center justify-center gap-2.5 text-sm font-medium text-gray-700" data-id="element-52">
            <MessageCircle className="w-5 h-5 text-blue-600" data-id="element-53" />
            <span data-id="element-54">Funciona con el WhatsApp que ya usas</span>
          </div>
          <div className="flex items-center justify-center gap-2.5 text-sm font-medium text-gray-700" data-id="element-55">
            <Settings className="w-5 h-5 text-blue-600" data-id="element-56" />
            <span data-id="element-57">Sin cambios para tu equipo</span>
          </div>
          <div className="flex items-center justify-center gap-2.5 text-sm font-medium text-gray-700" data-id="element-58">
            <Clock className="w-5 h-5 text-blue-600" data-id="element-59" />
            <span data-id="element-60">Implementación en menos de 48 horas</span>
          </div>
        </motion.div>
      </div>
    </section>;
}